export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-geo/src/identity.js
// module id = C1jE
// module chunks = 0